/**
 * EmailTemplateSection.tsx
 * メールテンプレート送信ボタン群（AI作成 / 決済御礼 / フリー / リクエスト系 / キャンセル系 / コメント返信）
 */
import React from 'react';
import { SectionProps } from '../types';
import SectionHeader from '../shared/SectionHeader';

interface EmailTemplateSectionProps extends SectionProps {
  onOpenEmailTemplate?: (type: string) => void;
}

const AI_COMPOSE_TEMPLATE = { type: 'ai_compose', label: '✨ AIで作成' } as const;

const EMAIL_TEMPLATES = [
  { type: 'payment', label: '決済御礼' },
  { type: 'free', label: 'フリー' },
  { type: 'request_ok', label: 'リクエスト OK' },
  { type: 'request_full', label: 'リクエスト full' },
  { type: 'request_offer', label: 'リクエスト offer' },
  { type: 'cancel', label: 'キャンセル（通常）' },
  { type: 'cancel_fee', label: 'キャンセル（C料金）' },
  { type: 'comment', label: 'comment' },
] as const;

const STANDARD_BUTTON_STYLE: React.CSSProperties = {
  padding: '4px 12px',
  fontSize: '0.75rem',
  border: 'none',
  borderRadius: 4,
  background: '#475569',
  color: '#fff',
};

const AI_BUTTON_STYLE: React.CSSProperties = {
  padding: '6px 14px',
  fontSize: '0.8rem',
  fontWeight: 600,
  border: 'none',
  borderRadius: 4,
  background: 'linear-gradient(135deg, #8b5cf6 0%, #6366f1 100%)',
  color: '#fff',
  boxShadow: '0 1px 3px rgba(99, 102, 241, 0.4)',
};

export default function EmailTemplateSection({
  disabled,
  isNew,
  onOpenEmailTemplate,
}: EmailTemplateSectionProps) {
  if (isNew || !onOpenEmailTemplate) return null;

  return (
    <>
      <SectionHeader title="メールテンプレート" />
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', padding: '8px 4px' }}>
        {/* AIで作成: トップ表示・色違いで目立たせる */}
        <button
          type="button"
          onClick={() => onOpenEmailTemplate(AI_COMPOSE_TEMPLATE.type)}
          disabled={disabled}
          style={{
            ...AI_BUTTON_STYLE,
            cursor: disabled ? 'default' : 'pointer',
            opacity: disabled ? 0.5 : 1,
          }}
        >
          {AI_COMPOSE_TEMPLATE.label}
        </button>
        {EMAIL_TEMPLATES.map((tpl) => (
          <button
            key={tpl.type}
            type="button"
            onClick={() => onOpenEmailTemplate(tpl.type)}
            disabled={disabled}
            style={{
              ...STANDARD_BUTTON_STYLE,
              cursor: disabled ? 'default' : 'pointer',
            }}
          >
            {tpl.label}
          </button>
        ))}
      </div>
    </>
  );
}
